const fetch = <T>(key: string): T | undefined => {
  const data = (window.DATA_PREFETCH || {})[key];

  if (!data) {
    return undefined;
  }

  return JSON.parse(data) as T;
};

export const usePrefetch = () => {
  return {
    fetch,
  };
};
